module.exports = __webpack_public_path__ + "assets/img/00040.05fca26b.png";